import { render, staticRenderFns } from "./TableComponentBuefy.vue?vue&type=template&id=8d83e372&scoped=true&"
import script from "./TableComponentBuefy.vue?vue&type=script&lang=js&"
export * from "./TableComponentBuefy.vue?vue&type=script&lang=js&"
import style0 from "./TableComponentBuefy.vue?vue&type=style&index=0&id=8d83e372&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d83e372",
  null
  
)

export default component.exports